export default "__VITE_ASSET__Cd6k6ez8__"